import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LinkedinShareButton, LinkedinIcon } from 'react-share';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import './SmallLinkedInButton.scss';
import { SHARE_DESTINATIONS } from '../CommunityShareButton/CommunitySharePopup/consts';

const SmallLinkedInButton = ({ hash, urlToShare, beforeOnClick, label }) => {
    const { isLoggedIn, wrapAuth } = useContext(PageContext);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const shareUrl = urlToShare || content.contentUrl;
    const labelCopy = label || 'LinkedIn';
    const authMetrics = {
        login_trigger: 'linkedIn-share',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
    };
    return wrapAuth(
        `linkedIn-share-${content.hash}`,
        <LinkedinShareButton
            className="component-Community-ReactionBar-SmallLinkedInButton"
            url={shareUrl}
            resetButtonStyle={false}
            beforeOnClick={() => beforeOnClick(SHARE_DESTINATIONS.LINKED_IN)}
            disabled={!isLoggedIn()}
            disabledStyle={{ opacity: 1 }}
        >
            <div className="icon-container">
                <LinkedinIcon size={25} borderRadius={5} />
            </div>
            <p className="label">{labelCopy}</p>
        </LinkedinShareButton>,
        authMetrics
    );
};

SmallLinkedInButton.propTypes = {
    hash: PropTypes.string.isRequired,
    urlToShare: PropTypes.string,
    onSuccess: PropTypes.func,
    label: PropTypes.string,
};

SmallLinkedInButton.defaultProps = {
    urlToShare: null,
    onSuccess: () => {},
    label: null,
};

SmallLinkedInButton.displayName = 'SmallLinkedInButton';

export default React.memo(SmallLinkedInButton);
